<template>
  <div>
    <table
        class="machine-inventory__table table-striped table-bordered"
        :class="{ print: prepareForPrint }"
    >
      <thead>
      <tr>
        <td colspan="2" class="text-center bg-secondary text-light">
          <div>
            <label class="mt-2">Inventário</label>
            <button
              v-if="!prepareForPrint && authenticated_user !== 'Cliente somente leitura'"
              @click="toggleEditable"
              class="btn btn-primary m-1 float-right"
            >
              {{ editable ? 'Salvar' : 'Editar' }}
            </button>
          </div>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Capacidade</td>
        <td>
          <!-- Antes era um <select> com só 2 opções fixas (SOB DEMANDA / NAO SOUBE
               INFORMAR): como o app mobile permite digitar qualquer texto livre (ex:
               "500 KG", "2000 L"), qualquer valor coletado que não fosse uma dessas
               duas strings exatas não batia com nenhuma <option selected>, e o
               <select> HTML cai silenciosamente pra primeira opção da lista — dando
               a impressão de que o valor real coletado sumiu / virou outro. Texto
               livre resolve isso e também é o que o app já coleta hoje. -->
          <input
            type="text"
            :class="{ 'not-selectable': !editable }"
            :disabled="!editable"
            :value="machine?.capacity"
            @change="changeCapacity($event)"
          />
        </td>
      </tr>
      <tr>
        <td>Tensão</td>
        <td>
          <!-- Bug real do "110V aparecendo em vez de 380V coletado": o backend salva
               o nome da tensão como "380V" (com sufixo V maiúsculo — ver
               MobileInspecaoController::store), mas esta lista de opções sempre foi
               ['110','220','380','440'], SEM o sufixo "V". A comparação
               `voltage === machine.voltage.name` portanto nunca batia com nenhuma
               opção, e o <select> HTML cai pra primeira opção da lista (110) sempre
               que isso acontece — não é o valor coletado, é o padrão do navegador
               quando nenhuma opção bate. Normalizando os dois lados (removendo o
               sufixo "v"/"V" antes de comparar) o valor real coletado passa a ser
               selecionado corretamente. -->
          <select @change="changeVoltage($event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option v-for="voltage in voltages"
                    :selected="voltage === (machine?.voltage?.name || '').replace(/v$/i, '')"
                    :value="voltage"
            >{{ voltage }}v
            </option>
          </select>
        </td>
      </tr>
      <tr>
        <td>Aterramento</td>
        <td>
          <select @change="changeGroundWire($event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option :selected="machine?.has_ground_wire" value="Sim">SIM</option>
            <option :selected="!machine?.has_ground_wire" value="Nao">NÃO</option>
          </select>
        </td>
      </tr>
      <tr v-for="safetySystem in safetySystems" :key="safetySystem.id">
        <td>{{ safetySystem.name }}</td>
        <td>
          <select @change="changeSafetySystem(safetySystem, $event)" :class="{ 'not-selectable': !editable }" :disabled="!editable">
            <option :selected="safetySistemValue(safetySystem) == 'Sim'" value="Sim">SIM</option>
            <option :selected="safetySistemValue(safetySystem) == 'Não'" value="Não">NÃO</option>
            <option :selected="safetySistemValue(safetySystem) == 'N/A'" value="N/A">N/A</option>
            <option :selected="safetySistemValue(safetySystem) == 'I/C'" value="I/C">I/C</option>
          </select>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
  props: {
    safetySystems: {
      type: Array,
      required: false,
      default: () => [],
    },
    machine: {
      type: Object,
      required: true,
    },
    prepareForPrint: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const store = useStore()

    const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

    return {
      voltages: ['110', '220', '380', '440'],
      capacities: ['SOB DEMANDA', 'NAO SOUBE INFORMAR'],
      editable: false,
      authenticated_user
    }
  },
  methods: {
    safetySistemValue(safetySystem) {
        const machineSafetySystem = this?.machine?.safety_systems.filter(mms => mms.id === safetySystem.id)[0]
        return machineSafetySystem.pivot.status
    },
    changeSafetySystem(safetySystem, event) {
      const value = event.target.value

      const data = {
        machine_id: this.machine.id,
        safety_system_id: safetySystem.id,
        value
      }

      axios.post('/api/safety_systems/update', data);
    },
    changeGroundWire(event) {
      const data = {
        machine_id: this.machine.id,
      }

      if (event.target.value === 'Sim') {
        axios.post('/api/ground_wire/enable', data);
      } else {
        axios.post('/api/ground_wire/disable', data);
      }
    },
    changeVoltage(event) {
      const data = {
        machine_id: this.machine.id,
        voltage: event.target.value
      }

      axios.post('/api/machines/voltage', data);
    },
    changeCapacity(event) {
      const data = {
        machine_id: this.machine.id,
        capacity: event.target.value
      }

      axios.post('/api/machines/capacity', data);
    },
    toggleEditable(event) {
      event.preventDefault()
      this.editable = !this.editable
    },
  },
}
</script>

<style lang="scss" scoped>
  .machine-inventory {
    &__table {
      width: 100%;

      &.print {
        font-size: 0.7rem;
      }
    }
  }

  .not-selectable {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none; 
    border: none;
    overflow:hidden;
    background: rgba(0, 0, 0, 0);
    width: 80%;
  }

  select:disabled {
    color: black;
  }

  @media print {
    select {
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none; 
      border: none;
      overflow:hidden;
      background: rgba(0, 0, 0, 0);
      width: 80%;
    }
  }
</style>
